module.exports = __webpack_public_path__ + "static/media/yamnaya_icon_medium.8b2905cf.png";